import { createAction } from "@reduxjs/toolkit";
import { MESSAGES_ADD_DIRECTIONS } from "../../../../packages/constants";
import { CHAT_ACTIONS } from "../../types";
import type { Message, AuthorList } from "../../types";

type ActionParams = {
  messages: Array<Message>;
  authors?: AuthorList;
  direction: MESSAGES_ADD_DIRECTIONS;
};

export const addMessages = createAction(
  CHAT_ACTIONS.ADD_MESSAGES,
  (data: ActionParams) => ({ payload: data })
);
